import { Component, signal } from '@angular/core';
import {CdcFooterComponent, CdcFooterConfig} from 'cdc-conte-ui-kit';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CdcFooterComponent],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export default class Footer {
   footer = signal<CdcFooterConfig>({
    id: 'mainFooter',
    dark: false,
    shadow: true,
    small: false,

    
/* columns visibility */ 
    showNewsletter:false,
    showSocials: false,

    brand: {
      iconName: 'code-circle',
      name: 'Nome ente',
      tagline: 'tag line',
    },

    linkColumns: [
      {
        title: 'Amministrazione',
        links: [
          { label: 'Giunta e consiglio' },
          { label: 'Aree di competenza' },
        ],
      },
      {
        title: 'Servizi',
        links: [
          { label: 'Pagamenti' },
          { label: 'Segnalazioni' },
        ],
      },
      {
        title: 'Novità',
        links: [
          { label: 'Notizie' },
          { label: 'Eventi' },
        ],
      },
      {
        title: 'Documenti',
        links: [
          { label: 'Bandi' },
          { label: 'Concorsi' },
        ],
      },
    ],

    contactBlocks: [
      {
        title: 'Nome della sede',
        text:
          'Nome dell indirizzo, n. civico' +
          'CAP Nome della città(Provincia)' +
          'Codice fiscale / P. IVA: 000000000',
        links: [
          { label: 'Posta Elettronica Certificata' },
          { label: 'URP - Ufficio Relazioni con il Pubblico' },
        ],
      },
    ],

    socialTitle: 'Seguici su',
    socials: [
      { iconName: 'designers-italia', srLabel: 'Designers Italia (link esterno)' },
      { iconName: 'twitter', srLabel: 'X (link esterno)' },
      { iconName: 'medium', srLabel: 'Medium (link esterno)' },
      { iconName: 'behance', srLabel: 'Behance (link esterno)' },
    ],

    smallLinks: [
      { label: 'Media policy' },
      { label: 'Note legali' },
      { label: 'Privacy policy' },
      { label: 'Mappa del sito' },
    ],
  });

 
  toggleDark() {
    this.footer.update(f => ({ ...f, dark: !f.dark }));
  }

}
